/*
 * dist/app.js -- every page except the chart. Theme, header menus, toasts,
 * plus the small page-specific bits that gate themselves on their markup.
 * base.html loads it in {% block bundle %}.
 */
import { Alpine, start } from '../boot/base.js';
import { firstAlertCard } from '../components/first-alert-card.js';
import { initIndicatorAutocomplete } from '../alerts/indicator-autocomplete.js';

initIndicatorAutocomplete();   // alarms_steps.html only; no-op elsewhere

Alpine.data('firstAlertCard', firstAlertCard);   // dashboard.html; inert on pages without the card

start();
